





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ThemeConfig } from '@/config/theme';

@Component({
  name: 'StatsCard'
})
export default class StatsCard extends Vue {
  @Prop({ required: true }) icon!: string;
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) value!: string | number;
  @Prop({ default: '' }) subtitle!: string;
  @Prop({ default: 'primary' }) color!: string;
  @Prop({ default: null }) trend!: 'up' | 'down' | null;
  @Prop({ default: '' }) trendValue!: string;
  @Prop({ default: 'white' }) iconColor!: string;

  get formattedValue(): string {
    if (typeof this.value === 'number') {
      return this.value.toLocaleString();
    }
    return this.value;
  }

  get iconWrapperStyle(): any {
    const colorMap: any = {
      primary: ThemeConfig.colors.primary,
      secondary: ThemeConfig.colors.secondary,
      accent: ThemeConfig.colors.accent,
      error: ThemeConfig.colors.error,
      warning: ThemeConfig.colors.warning,
      info: ThemeConfig.colors.info,
      success: ThemeConfig.colors.success,
    };

    const bgColor = colorMap[this.color] || this.color;

    return {
      background: bgColor,
    };
  }

  get trendClass(): string {
    return this.trend === 'up' ? 'trend-up' : 'trend-down';
  }

  get trendIcon(): string {
    return this.trend === 'up' ? 'mdi-trending-up' : 'mdi-trending-down';
  }
}
